import React from 'react';
import {useThemeColor} from "../DarkModeContext";
import {Typography} from "@mui/material";

const styles = {
    default: {
        fontSize: '16px',
        lineHeight: '24px',
        fontFamily: 'Eczar',
    },
    defaultSemiBold: {
        fontFamily: 'Roboto Condensed',
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 600,
    },
    title: {
        fontSize: '40px',
        fontWeight: 'bold',
        lineHeight: '40px',
        fontFamily: 'Roboto Condensed',
    },
    subtitle: {
        fontSize: '18px',
        fontWeight: '500',
        lineHeight: '40px',
        fontFamily: 'Roboto Condensed',
    },
    link: {
        lineHeight: '30px',
        fontSize: '16px',
        color: '#0a7ea4',
    },
};

export function ThemedText({
                               style,
                               lightColor,
                               darkColor,
                               type = 'default',
                                align = 'left',
                               ...rest
                           }) {
    // Simulating `useThemeColor` logic: Implement this based on your app's theme logic
    const color = useThemeColor({light: lightColor, dark: darkColor}, 'text');

    return (
        <Typography
            align={align}
            style={{
                color,
                ...(type === 'default' ? styles.default : {}),
                ...(type === 'title' ? styles.title : {}),
                ...(type === 'defaultSemiBold' ? styles.defaultSemiBold : {}),
                ...(type === 'subtitle' ? styles.subtitle : {}),
                ...(type === 'link' ? styles.link : {}),
                ...style,
            }}
            {...rest}
        />
    );
}
